
<div class="wrapper">
  <app-header (toggleMenuSidebar)="toggleMenuSidebar()"></app-header>
  <!--*ngIf="accountDetails" [account]="accountDetails"   [account]="accountDetails"-->
  <app-menu-sidebar (toggleMenuSidebar)="toggleMenuSidebar()" (mainSidebarHeight)="mainSidebarHeight($event)"></app-menu-sidebar>

  <div #contentWrapper class="content-wrapper">
    <div class="container-fluid pt-1">

      <div class="app-splash">
      </div>
      <router-outlet></router-outlet>
      <!--<app-cc-portal></app-cc-portal>-->
      <!--<app-customer-inspection></app-customer-inspection>-->
    </div>
  </div>

  <app-footer></app-footer>
  <aside class="control-sidebar control-sidebar-dark"></aside>
  <div id="sidebar-overlay" (click)="toggleMenuSidebar()"></div>

</div>
